import { Modal } from 'antd';
import React from 'react';

const SuccessBookAppointmentModal = (props) => {
    return (
        <>
            <Modal
                title={null}
                open={props.visible}
                onCancel={() => props.onClose()}
                footer={null}
                className="base__modal egmodal"
                style={{ top: 20 }}
            >
                <div className="eg__title_big">Service Appointment</div>
                <br />
                <div>Thanks for your request for the service equipment.</div>
                <br />
                <div className="eg__row">
                    <span className="eg__title">Product:</span>
                    <span className="eg__desc">
                        On the back behind the hose, on the base between the wheels, or on the main body behind the bin.
                    </span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Model:</span>
                    <span className="eg__desc">
                        Underneath the machine between the wheels, or on the main body behind the bin.
                    </span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Date purchased:</span>
                    <span className="eg__desc">On the main body behind the filter or behind the bin.</span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Name</span>
                    <span className="eg__desc">On the base of the machine.</span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Contant No:</span>
                    <span className="eg__desc">On the base of the machine.</span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Email Address</span>
                    <span className="eg__desc">On the base of the machine.</span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Service Outlet</span>
                    <span className="eg__desc">On the base of the machine.</span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Service Appointment Date</span>
                    <span className="eg__desc">On the base of the machine.</span>
                </div>
                <div className="eg__row">
                    <span className="eg__title">Service Appointment Time</span>
                    <span className="eg__desc">On the base of the machine.</span>
                </div>
            </Modal>
        </>
    );
};

export default SuccessBookAppointmentModal;
